// Brand Dependency data for USMNT
// NOTE: percentOfTeam values are bucketed (rounded to nearest 5%) for anti-inference formatting.
export const brandDependencyData = {
  // Player brand concentration data
  players: [
    {
      id: 'pulisic',
      name: 'Christian Pulisic',
      brandScore: 78,
      brandValue: 85, // in millions
      percentOfTeam: 35,
      replaceability: 'low',
      injuryImpact: {
        brandDecline: 8,
        valueDecline: 25,
      },
      position: 'Winger',
      age: 26,
    },
    {
      id: 'mckennie',
      name: 'Weston McKennie',
      brandScore: 65,
      brandValue: 45,
      percentOfTeam: 20,
      replaceability: 'medium',
      injuryImpact: {
        brandDecline: 4,
        valueDecline: 12,
      },
      position: 'Midfielder',
      age: 26,
    },
    {
      id: 'adams',
      name: 'Tyler Adams',
      brandScore: 62,
      brandValue: 38,
      percentOfTeam: 15,
      replaceability: 'medium',
      injuryImpact: {
        brandDecline: 3,
        valueDecline: 10,
      },
      position: 'Midfielder',
      age: 25,
    },
  ],
  
  // Team concentration metrics
  concentration: {
    top1Percent: 35,
    top3Percent: 70,
    remainingPercent: 30,
    brandConcentrationIndex: 72,
    riskLevel: 'high',
    optimalThreshold: 25,
  },
  
  // Team baseline metrics
  teamBaseline: {
    brandScore: 71,
    brandValueLow: 240,
    brandValueHigh: 340,
    concacafRank: 1,
  },
};

// Scenario definitions
export const scenarioDefinitions = {
  no_injury: {
    id: 'no_injury',
    label: 'No Injury (Baseline)',
    description: 'Full roster available',
    brandScoreAdjustment: 0,
    valueLowAdjustment: 0,
    valueHighAdjustment: 0,
    rankShift: 0,
    riskLevel: 'low',
  },
  top_player_injury: {
    id: 'top_player_injury',
    label: 'Top Player Injury',
    description: 'Pulisic unavailable for 3 months',
    brandScoreAdjustment: -8,
    valueLowAdjustment: -25,
    valueHighAdjustment: -35,
    rankShift: 0,
    riskLevel: 'medium',
  },
  two_key_players: {
    id: 'two_key_players',
    label: 'Two Key Players Injury',
    description: 'Pulisic + McKennie unavailable',
    brandScoreAdjustment: -12,
    valueLowAdjustment: -40,
    valueHighAdjustment: -55,
    rankShift: 1,
    riskLevel: 'high',
  },
  early_exit: {
    id: 'early_exit',
    label: 'Early Tournament Exit',
    description: 'Group stage elimination in 2026',
    brandScoreAdjustment: -15,
    valueLowAdjustment: -60,
    valueHighAdjustment: -80,
    rankShift: 2,
    riskLevel: 'high',
  },
};

export const scenarioOptions = Object.values(scenarioDefinitions).map(s => ({
  value: s.id,
  label: s.label,
  description: s.description,
}));
